var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 378,
    viewBox: "0 0 433 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2677_3332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 425,
    height: 370,
    rx: 24,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.799 307.09V278.735H177.091V307.09C177.091 307.09 177.253 319.672 161.788 319.672H219.946H278.103C262.637 319.672 262.799 307.09 262.799 307.09Z",
    fill: "#6DB6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.424 326.332H157.47C155.799 326.332 154.431 324.964 154.431 323.293V322.712C154.431 321.04 155.799 319.673 157.47 319.673H282.425C284.096 319.673 285.464 321.04 285.464 322.712V323.293C285.464 324.964 284.096 326.332 282.424 326.332Z",
    fill: "#A0DFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.091 303.131V278.735H262.799V288.524L177.091 303.131Z",
    fill: "#58A5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.658 275.698C358.658 281.267 354.101 285.824 348.531 285.824H91.3599C85.7906 285.824 81.2336 281.267 81.2336 275.698V122.922C81.2336 117.353 85.7906 112.796 91.3599 112.796H348.531C354.101 112.796 358.658 117.353 358.658 122.922V275.698Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.942 121.473H89.9486V235.987H349.942V121.473Z",
    fill: "#F8E4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2336 245.089V275.7C81.2336 281.269 85.7906 285.827 91.3599 285.827H348.531C354.101 285.827 358.658 281.269 358.658 275.7V245.089H81.2336Z",
    fill: "#83C2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.072 126.958C181.072 130.45 181.072 133.943 181.072 137.435C181.072 145.82 181.072 154.205 181.072 162.59C181.072 172.688 181.072 182.786 181.072 192.883C181.072 201.653 181.072 210.423 181.072 219.192C181.072 222.083 181.072 224.974 181.072 227.864C181.072 229.217 180.955 230.63 181.072 231.98C181.076 232.038 181.072 232.1 181.072 232.16C181.072 233.001 182.38 233.003 182.38 232.16C182.38 228.667 182.38 225.175 182.38 221.683C182.38 213.297 182.38 204.913 182.38 196.527C182.38 186.43 182.38 176.332 182.38 166.234C182.38 157.464 182.38 148.695 182.38 139.924C182.38 137.034 182.38 134.143 182.38 131.252C182.38 129.899 182.496 128.487 182.38 127.138C182.375 127.078 182.38 127.017 182.38 126.958C182.38 126.116 181.072 126.115 181.072 126.958Z",
    fill: "#EFD9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.418 126.958C255.418 130.45 255.418 133.943 255.418 137.435C255.418 145.82 255.418 154.205 255.418 162.59C255.418 172.688 255.418 182.786 255.418 192.883C255.418 201.653 255.418 210.423 255.418 219.192C255.418 222.083 255.418 224.974 255.418 227.864C255.418 229.217 255.302 230.63 255.418 231.98C255.423 232.038 255.418 232.1 255.418 232.16C255.418 233.001 256.725 233.003 256.725 232.16C256.725 228.667 256.725 225.175 256.725 221.683C256.725 213.297 256.725 204.913 256.725 196.527C256.725 186.43 256.725 176.332 256.725 166.234C256.725 157.464 256.725 148.695 256.725 139.924C256.725 137.034 256.725 134.143 256.725 131.252C256.725 129.899 256.842 128.487 256.725 127.138C256.721 127.078 256.725 127.017 256.725 126.958C256.725 126.116 255.418 126.115 255.418 126.958Z",
    fill: "#EFD9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.178 170.327C195.178 182.88 205.354 193.055 217.906 193.055C230.458 193.055 240.634 182.879 240.634 170.327C240.634 157.775 230.458 147.599 217.906 147.599C205.353 147.599 195.178 157.775 195.178 170.327ZM231.894 170.327C231.894 178.053 225.631 184.315 217.906 184.315C210.18 184.315 203.917 178.053 203.917 170.327C203.917 162.601 210.18 156.339 217.906 156.339C225.631 156.339 231.894 162.601 231.894 170.327Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.906 156.339C225.631 156.339 231.894 162.601 231.894 170.327H240.634C240.634 157.775 230.458 147.599 217.906 147.599C205.354 147.599 195.178 157.775 195.178 170.327H203.917C203.917 162.601 210.18 156.339 217.906 156.339Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.906 147.599C212.344 147.599 207.252 149.6 203.301 152.917L208.919 159.614C211.35 157.573 214.483 156.339 217.906 156.339C225.632 156.339 231.894 162.601 231.894 170.327H240.634C240.634 157.775 230.458 147.599 217.906 147.599Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.218 163.685C231.287 165.662 231.895 167.923 231.895 170.328H240.635C240.635 166.421 239.648 162.744 237.912 159.534L230.218 163.685Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 201.103H193.634V203.895H242.176V201.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.842 201.103H193.634V203.895H212.842V201.103Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 209.203H193.634V211.996H242.176V209.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.717 209.203H193.634V211.996H224.717V209.203Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 217.302H193.634V220.095H242.176V217.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.386 217.302H193.634V220.095H205.386V217.302Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 225.404H193.634V228.196H242.176V225.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.868 225.404H193.634V228.196H234.868V225.404Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.907 128.796H193.636V130.953H217.907V128.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.398 134.031H193.634V136.948H243.398V134.031Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.053 139.261H193.634V142.178H231.053V139.261Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.997 156.158H97.5962V126.484H99.2759V154.479H136.997V156.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.975 141.322H102.163V152.317H106.975V141.322Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.375 136.358H110.563V152.318H115.375V136.358Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.778 146.82H118.966V152.317H123.778V146.82Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.178 130.334H127.366V152.318H132.178V130.334Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.294 127.752H142.535V129.909H156.294V127.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.746 132.983H142.535V135.901H170.746V132.983Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.746 138.214H142.535V141.131H170.746V138.214Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.384 143.446H142.535V146.364H164.384V143.446Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 166.891C103.52 168.553 102.173 169.9 100.511 169.9C98.8495 169.9 97.502 168.553 97.502 166.891C97.502 165.23 98.8495 163.882 100.511 163.882C102.173 163.882 103.52 165.23 103.52 166.891Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 163.882H107.449V166.038H121.208V163.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 168.234H107.449V171.151H169.698V168.234Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.437 173.466H107.449V176.383H154.437V173.466Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 184.68C103.52 186.342 102.173 187.689 100.511 187.689C98.8495 187.689 97.502 186.342 97.502 184.68C97.502 183.018 98.8495 181.671 100.511 181.671C102.173 181.671 103.52 183.018 103.52 184.68Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 181.671H107.449V183.827H121.208V181.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 186.023H107.449V188.94H169.698V186.023Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.437 191.255H107.449V194.172H154.437V191.255Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 202.467C103.52 204.129 102.173 205.476 100.511 205.476C98.8495 205.476 97.502 204.129 97.502 202.467C97.502 200.806 98.8495 199.458 100.511 199.458C102.173 199.458 103.52 200.806 103.52 202.467Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 199.458H107.449V201.614H121.208V199.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 203.807H107.449V206.725H169.698V203.807Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.437 209.039H107.449V211.957H154.437V209.039Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 220.253C103.52 221.915 102.173 223.262 100.511 223.262C98.8495 223.262 97.502 221.915 97.502 220.253C97.502 218.592 98.8495 217.244 100.511 217.244C102.173 217.244 103.52 218.592 103.52 220.253Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 217.244H107.449V219.4H121.208V217.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 221.595H107.449V224.512H169.698V221.595Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.437 226.827H107.449V229.744H154.437V226.827Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.657 164.05H264.251V128.577H266.259V162.042H341.657V164.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.656 132.619H266.258V136.282H341.656V132.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.013 132.619H266.258V136.282H335.013V132.619Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.656 139.942H266.258V143.604H341.656V139.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.277 139.942H266.258V143.604H285.277V139.942Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.656 147.269H266.258V150.931H341.656V147.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.682 147.269H266.258V150.931H320.682V147.269Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.656 154.592H266.258V158.254H341.656V154.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.748 154.592H266.258V158.254H296.748V154.592Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.657 171.485H264.251V174.402H341.657V171.485Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68 176.715H264.251V179.632H322.68V176.715Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.177 198.543C280.895 193.884 277.701 189.525 273.042 188.808C268.383 188.09 264.024 191.284 263.306 195.943C262.588 200.602 265.783 204.961 270.442 205.679C275.101 206.397 279.46 203.202 280.177 198.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.452 193.579C278.084 190.689 275.151 188.685 271.741 188.685V197.22L279.452 193.579Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.854 198.587C301.611 193.934 298.453 189.549 293.801 188.792C289.148 188.035 284.763 191.193 284.005 195.846C283.248 200.498 286.406 204.884 291.059 205.641C295.712 206.398 300.097 203.24 300.854 198.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.165 200.843C300.683 199.742 300.981 198.518 300.981 197.221C300.981 192.507 297.159 188.685 292.445 188.685V197.221L300.165 200.843Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.498 198.867C322.409 194.242 319.399 189.755 314.774 188.843C310.149 187.932 305.661 190.943 304.75 195.568C303.839 200.192 306.849 204.68 311.474 205.592C316.099 206.503 320.587 203.492 321.498 198.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.654 189.981C316.344 189.165 314.804 188.686 313.148 188.686V197.221L317.654 189.981Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.882 203.257C343.215 199.924 343.215 194.52 339.882 191.187C336.549 187.853 331.144 187.853 327.811 191.187C324.478 194.52 324.478 199.924 327.811 203.257C331.145 206.591 336.549 206.591 339.882 203.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.386 197.221C342.386 192.507 338.564 188.685 333.851 188.685V205.756C338.564 205.756 342.386 201.934 342.386 197.221Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.476 214.436H263.205V216.592H287.476V214.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.658 219.665H263.205V222.583H341.658V219.665Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.197 224.897H263.205V227.815H322.197V224.897Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M89.9484 235.987L349.941 121.473V235.987H89.9484Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.799 307.089V278.735H177.091V307.089C177.091 307.089 177.253 319.672 161.788 319.672H219.946H278.103C262.637 319.672 262.799 307.089 262.799 307.089Z",
    fill: "#6DB6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.424 326.332H157.47C155.799 326.332 154.431 324.964 154.431 323.293V322.711C154.431 321.04 155.799 319.673 157.47 319.673H282.425C284.096 319.673 285.464 321.04 285.464 322.711V323.293C285.464 324.964 284.096 326.332 282.424 326.332Z",
    fill: "#A0DFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.091 303.131V278.735H262.799V288.524L177.091 303.131Z",
    fill: "#58A5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.657 275.698C358.657 281.267 354.1 285.824 348.531 285.824H91.3597C85.7904 285.824 81.2334 281.267 81.2334 275.698V122.922C81.2334 117.353 85.7904 112.796 91.3597 112.796H348.531C354.1 112.796 358.657 117.353 358.657 122.922V275.698Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.942 121.473H89.9484V235.987H349.942V121.473Z",
    fill: "#F8E4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2334 245.089V275.7C81.2334 281.269 85.7904 285.826 91.3597 285.826H348.531C354.1 285.826 358.657 281.269 358.657 275.7V245.089H81.2334Z",
    fill: "#83C2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.799 307.089V278.735H177.091V307.089C177.091 307.089 177.253 319.672 161.788 319.672H219.945H278.103C262.637 319.672 262.799 307.089 262.799 307.089Z",
    fill: "#6DB6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.424 326.331H157.47C155.799 326.331 154.431 324.964 154.431 323.293V322.711C154.431 321.04 155.799 319.672 157.47 319.672H282.425C284.096 319.672 285.463 321.04 285.463 322.711V323.293C285.463 324.964 284.096 326.331 282.424 326.331Z",
    fill: "#A0DFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09 303.131V278.735H262.799V288.524L177.09 303.131Z",
    fill: "#58A5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.657 275.698C358.657 281.267 354.1 285.824 348.531 285.824H91.3596C85.7903 285.824 81.2332 281.267 81.2332 275.698V122.922C81.2332 117.353 85.7903 112.796 91.3596 112.796H348.531C354.1 112.796 358.657 117.353 358.657 122.922V275.698Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.941 121.472H89.9482V235.987H349.941V121.472Z",
    fill: "#F8E4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2332 245.089V275.7C81.2332 281.269 85.7903 285.826 91.3596 285.826H348.531C354.1 285.826 358.657 281.269 358.657 275.7V245.089H81.2332Z",
    fill: "#83C2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.071 126.958C181.071 130.45 181.071 133.942 181.071 137.435C181.071 145.82 181.071 154.205 181.071 162.59C181.071 172.688 181.071 182.785 181.071 192.883C181.071 201.652 181.071 210.423 181.071 219.192C181.071 222.083 181.071 224.973 181.071 227.864C181.071 229.217 180.955 230.63 181.071 231.98C181.076 232.038 181.071 232.1 181.071 232.159C181.071 233.001 182.38 233.003 182.38 232.159C182.38 228.667 182.38 225.175 182.38 221.683C182.38 213.297 182.38 204.913 182.38 196.527C182.38 186.429 182.38 176.332 182.38 166.234C182.38 157.464 182.38 148.694 182.38 139.924C182.38 137.033 182.38 134.143 182.38 131.252C182.38 129.899 182.496 128.487 182.38 127.137C182.375 127.078 182.38 127.017 182.38 126.958C182.38 126.115 181.071 126.115 181.071 126.958Z",
    fill: "#EFD9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.418 126.958C255.418 130.45 255.418 133.942 255.418 137.435C255.418 145.82 255.418 154.205 255.418 162.59C255.418 172.688 255.418 182.785 255.418 192.883C255.418 201.652 255.418 210.423 255.418 219.192C255.418 222.083 255.418 224.973 255.418 227.864C255.418 229.217 255.301 230.63 255.418 231.98C255.423 232.038 255.418 232.1 255.418 232.159C255.418 233.001 256.725 233.003 256.725 232.159C256.725 228.667 256.725 225.175 256.725 221.683C256.725 213.297 256.725 204.913 256.725 196.527C256.725 186.429 256.725 176.332 256.725 166.234C256.725 157.464 256.725 148.694 256.725 139.924C256.725 137.033 256.725 134.143 256.725 131.252C256.725 129.899 256.842 128.487 256.725 127.137C256.72 127.078 256.725 127.017 256.725 126.958C256.725 126.115 255.418 126.115 255.418 126.958Z",
    fill: "#EFD9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.178 170.327C195.178 182.88 205.354 193.055 217.905 193.055C230.457 193.055 240.633 182.879 240.633 170.327C240.633 157.775 230.457 147.599 217.905 147.599C205.353 147.599 195.178 157.775 195.178 170.327ZM231.894 170.327C231.894 178.052 225.631 184.315 217.905 184.315C210.18 184.315 203.917 178.052 203.917 170.327C203.917 162.601 210.18 156.339 217.905 156.339C225.631 156.339 231.894 162.601 231.894 170.327Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.905 156.339C225.631 156.339 231.894 162.601 231.894 170.327H240.633C240.633 157.775 230.457 147.599 217.905 147.599C205.354 147.599 195.178 157.775 195.178 170.327H203.917C203.917 162.601 210.18 156.339 217.905 156.339Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.906 147.599C212.344 147.599 207.251 149.6 203.301 152.917L208.919 159.614C211.35 157.572 214.482 156.339 217.906 156.339C225.632 156.339 231.894 162.601 231.894 170.327H240.634C240.634 157.775 230.458 147.599 217.906 147.599Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.218 163.685C231.287 165.662 231.895 167.923 231.895 170.328H240.635C240.635 166.421 239.648 162.744 237.912 159.534L230.218 163.685Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 201.103H193.634V203.895H242.176V201.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.842 201.103H193.634V203.895H212.842V201.103Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 209.203H193.634V211.995H242.176V209.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.716 209.203H193.634V211.995H224.716V209.203Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 217.302H193.634V220.095H242.176V217.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.385 217.302H193.634V220.095H205.385V217.302Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.176 225.403H193.634V228.196H242.176V225.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.868 225.403H193.634V228.196H234.868V225.403Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.907 128.796H193.636V130.952H217.907V128.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.397 134.03H193.634V136.948H243.397V134.03Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.053 139.26H193.634V142.178H231.053V139.26Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.996 156.158H97.596V126.484H99.2757V154.478H136.996V156.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.975 141.322H102.163V152.317H106.975V141.322Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.374 136.358H110.562V152.317H115.374V136.358Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.778 146.819H118.966V152.317H123.778V146.819Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.177 130.333H127.365V152.318H132.177V130.333Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.293 127.752H142.534V129.908H156.293V127.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.746 132.983H142.534V135.9H170.746V132.983Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.746 138.214H142.534V141.131H170.746V138.214Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.384 143.446H142.534V146.363H164.384V143.446Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 166.891C103.52 168.553 102.173 169.9 100.511 169.9C98.8493 169.9 97.5019 168.553 97.5019 166.891C97.5019 165.23 98.8493 163.882 100.511 163.882C102.173 163.882 103.52 165.23 103.52 166.891Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 163.882H107.449V166.038H121.208V163.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 168.233H107.449V171.151H169.698V168.233Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 173.465H107.449V176.383H154.436V173.465Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 184.68C103.52 186.341 102.173 187.689 100.511 187.689C98.8493 187.689 97.5019 186.341 97.5019 184.68C97.5019 183.018 98.8493 181.671 100.511 181.671C102.173 181.671 103.52 183.018 103.52 184.68Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 181.671H107.449V183.827H121.208V181.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 186.023H107.449V188.94H169.698V186.023Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 191.255H107.449V194.172H154.436V191.255Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 202.467C103.52 204.128 102.173 205.476 100.511 205.476C98.8493 205.476 97.5019 204.128 97.5019 202.467C97.5019 200.805 98.8493 199.458 100.511 199.458C102.173 199.458 103.52 200.805 103.52 202.467Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 199.458H107.449V201.614H121.208V199.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 203.807H107.449V206.724H169.698V203.807Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 209.039H107.449V211.956H154.436V209.039Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52 220.253C103.52 221.915 102.173 223.262 100.511 223.262C98.8493 223.262 97.5019 221.915 97.5019 220.253C97.5019 218.591 98.8493 217.244 100.511 217.244C102.173 217.244 103.52 218.591 103.52 220.253Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.208 217.244H107.449V219.4H121.208V217.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.698 221.594H107.449V224.512H169.698V221.594Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.436 226.826H107.449V229.744H154.436V226.826Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.657 164.05H264.251V128.577H266.259V162.042H341.657V164.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.655 132.619H266.258V136.281H341.655V132.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.013 132.619H266.258V136.281H335.013V132.619Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.655 139.942H266.258V143.604H341.655V139.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.277 139.942H266.258V143.604H285.277V139.942Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.655 147.269H266.258V150.931H341.655V147.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.682 147.269H266.258V150.931H320.682V147.269Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.655 154.592H266.258V158.254H341.655V154.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.748 154.592H266.258V158.254H296.748V154.592Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.657 171.485H264.251V174.402H341.657V171.485Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68 176.715H264.251V179.632H322.68V176.715Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.177 198.543C280.895 193.884 277.701 189.525 273.042 188.807C268.383 188.089 264.024 191.284 263.306 195.943C262.588 200.602 265.783 204.96 270.442 205.678C275.101 206.396 279.459 203.202 280.177 198.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.452 193.578C278.084 190.689 275.151 188.684 271.741 188.684V197.22L279.452 193.578Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.854 198.587C301.611 193.934 298.453 189.549 293.801 188.792C289.148 188.035 284.762 191.193 284.005 195.845C283.248 200.498 286.406 204.883 291.059 205.641C295.712 206.398 300.097 203.24 300.854 198.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.165 200.843C300.683 199.742 300.981 198.517 300.981 197.22C300.981 192.507 297.159 188.685 292.445 188.685V197.22L300.165 200.843Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.498 198.867C322.409 194.242 319.398 189.754 314.774 188.843C310.149 187.932 305.661 190.942 304.75 195.567C303.838 200.192 306.849 204.68 311.474 205.591C316.099 206.503 320.587 203.492 321.498 198.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.654 189.981C316.344 189.165 314.804 188.685 313.148 188.685V197.221L317.654 189.981Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.882 203.257C343.215 199.924 343.215 194.52 339.882 191.186C336.549 187.853 331.144 187.853 327.811 191.186C324.478 194.52 324.478 199.924 327.811 203.257C331.144 206.59 336.549 206.59 339.882 203.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.386 197.22C342.386 192.507 338.564 188.685 333.851 188.685V205.756C338.564 205.756 342.386 201.934 342.386 197.22Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.476 214.436H263.205V216.592H287.476V214.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.657 219.665H263.205V222.582H341.657V219.665Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.196 224.897H263.205V227.815H322.196V224.897Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M89.9482 235.987L349.94 121.472V235.987H89.9482Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.597 326.673H50.3209V210.613L70.6109 190.258H157.597V326.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6116 190.258L50.2882 210.58H70.6116V190.258Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 258.949H65.2394V223.476H67.2487V256.941H142.646V258.949Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 227.518H67.2483V231.181H142.646V227.518Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.003 227.518H67.2483V231.181H136.003V227.518Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 234.843H67.2483V238.505H142.646V234.843Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2671 234.843H67.2483V238.505H86.2671V234.843Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 242.166H67.2483V245.828H142.646V242.166Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.672 242.166H67.2483V245.828H121.672V242.166Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 249.49H67.2483V253.152H142.646V249.49Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7381 249.49H67.2483V253.152H97.7381V249.49Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8453 200.989H77.7114V203.146H99.8453V200.989Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.891 206.22H77.7109V209.137H137.891V206.22Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.963 211.452H77.7109V214.369H122.963V211.452Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6976 273.167C61.8837 273.167 57.9808 277.069 57.9808 281.884C57.9808 286.699 61.8837 290.601 66.6976 290.601C71.5116 290.601 75.4145 286.698 75.4145 281.884C75.4145 277.07 71.5116 273.167 66.6976 273.167ZM66.6976 288.778C62.8902 288.778 59.8048 285.692 59.8048 281.884C59.8048 278.077 62.8912 274.99 66.6976 274.99C70.505 274.99 73.5905 278.077 73.5905 281.884C73.5905 285.692 70.505 288.778 66.6976 288.778Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7834 278.647L74.3925 277.79C72.9266 275.04 70.0322 273.167 66.6984 273.167V274.99C69.3351 274.991 71.6241 276.473 72.7834 278.647Z",
    fill: "#FF9A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3391 293.848H57.0547V296.004H76.3391V293.848Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3387 299.081H57.0544V301.998H76.3387V299.081Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0544 304.312V307.229H71.5554H76.3387V304.312H71.5554H57.0544Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5554 309.543H57.0544V309.816V312.46V312.733H76.3387V309.816H71.5554V309.543Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5554 315.048H57.0544V317.966H71.5554V315.048Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.528 273.167C86.7141 273.167 82.8112 277.069 82.8112 281.884C82.8112 286.699 86.7141 290.601 91.528 290.601C96.342 290.601 100.245 286.698 100.245 281.884C100.245 277.07 96.342 273.167 91.528 273.167ZM91.528 288.778C87.7206 288.778 84.6352 285.692 84.6352 281.884C84.6352 278.077 87.7216 274.99 91.528 274.99C95.3355 274.99 98.4209 278.077 98.4209 281.884C98.4209 285.692 95.3355 288.778 91.528 288.778Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.528 273.167V274.99C95.3354 274.99 98.4208 278.077 98.4208 281.884H100.244C100.245 277.07 96.3419 273.167 91.528 273.167Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17 293.848H81.8861V296.004H101.17V293.848Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.171 299.081H81.8865V301.998H101.171V299.081Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8865 304.312V307.229H96.3875H101.171V304.312H96.3875H81.8865Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3875 309.543H81.8865V309.816V312.46V312.733H101.171V309.816H96.3875V309.543Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3875 315.048H81.8865V317.966H96.3875V315.048Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.355 273.168C111.541 273.168 107.638 277.07 107.638 281.885C107.638 286.7 111.541 290.602 116.355 290.602C121.169 290.602 125.072 286.699 125.072 281.885C125.072 277.071 121.169 273.168 116.355 273.168ZM116.355 288.779C112.548 288.779 109.462 285.692 109.462 281.885C109.462 278.077 112.549 274.991 116.355 274.991C120.163 274.991 123.248 278.077 123.248 281.885C123.248 285.692 120.163 288.779 116.355 288.779Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.296 276.232L121.338 274.737C119.926 273.751 118.209 273.167 116.356 273.167V274.991C117.822 274.991 119.179 275.451 120.296 276.232Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 293.848H106.716V296.004H126V293.848Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 299.081H106.716V301.998H126V299.081Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.716 304.312V307.229H121.217H126V304.312H121.217H106.716Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.217 309.543H106.716V309.816V312.46V312.733H126V309.816H121.217V309.543Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.217 315.048H106.716V317.966H121.217V315.048Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.185 273.168C136.371 273.168 132.468 277.07 132.468 281.885C132.468 286.7 136.371 290.602 141.185 290.602C145.999 290.602 149.902 286.699 149.902 281.885C149.902 277.071 145.999 273.168 141.185 273.168ZM141.185 288.779C137.377 288.779 134.292 285.693 134.292 281.885C134.292 278.078 137.378 274.991 141.185 274.991C144.992 274.991 148.078 278.078 148.078 281.885C148.078 285.693 144.992 288.779 141.185 288.779Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.185 273.167C141.162 273.167 141.14 273.17 141.117 273.171V274.994C141.14 274.994 141.162 274.99 141.185 274.99C144.993 274.99 148.078 278.077 148.078 281.884C148.078 285.692 144.992 288.777 141.185 288.777C141.162 288.777 141.14 288.774 141.117 288.773V290.596C141.14 290.596 141.162 290.6 141.185 290.6C145.999 290.6 149.902 286.697 149.902 281.883C149.902 277.069 145.999 273.167 141.185 273.167Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.827 293.848H131.543V296.004H150.827V293.848Z",
    fill: "#E5C78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.828 299.081H131.543V301.998H150.828V299.081Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.543 304.312V307.229H146.044H150.828V304.312H146.044H131.543Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.044 309.543H131.543V309.816V312.46V312.733H150.828V309.816H146.044V309.543Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.044 315.048H131.543V317.966H146.044V315.048Z",
    fill: "#EFEAE1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M50.3215 326.674L157.597 190.259V326.674H50.3215Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.116 266.42L345.597 270.266L373.283 324.393L380.802 320.547L353.116 266.42Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.062 270.123C358.917 271.794 358.249 273.861 356.578 274.716L350.277 277.939C348.606 278.793 346.54 278.126 345.685 276.455L343.717 272.607C342.862 270.936 343.53 268.869 345.201 268.015L351.502 264.792C353.173 263.937 355.239 264.605 356.094 266.276L358.062 270.123Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.339 317.586C383.193 319.257 382.526 321.324 380.855 322.178L374.554 325.401C372.883 326.256 370.816 325.588 369.961 323.917L367.993 320.07C367.139 318.399 367.806 316.332 369.477 315.477L375.778 312.254C377.449 311.4 379.516 312.067 380.37 313.738L382.339 317.586Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.634 202.439C296.735 212.105 289.251 235.262 298.917 254.16C308.584 273.059 331.74 280.543 350.639 270.877C369.537 261.211 377.021 238.054 367.355 219.155C357.689 200.257 334.533 192.773 315.634 202.439ZM347.267 264.282C332.01 272.086 313.316 266.044 305.513 250.787C297.709 235.531 303.751 216.837 319.008 209.034C334.264 201.23 352.957 207.272 360.761 222.528C368.564 237.785 362.523 256.479 347.267 264.282Z",
    fill: "#0082C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M364.025 239.921C365.827 222.879 353.473 207.602 336.431 205.799C319.389 203.996 304.112 216.35 302.309 233.392C300.506 250.435 312.86 265.712 329.903 267.514C346.945 269.317 362.222 256.963 364.025 239.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M347.693 216.707C349.371 219.988 348.072 224.009 344.79 225.688C341.509 227.367 337.488 226.067 335.809 222.786C334.13 219.505 335.43 215.484 338.711 213.805C341.993 212.126 346.015 213.426 347.693 216.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M346.992 200.814L323.194 273.784C332.067 276.163 341.817 275.391 350.64 270.878C369.539 261.212 377.023 238.055 367.357 219.156C362.877 210.4 355.499 204.099 346.992 200.814Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.508 119.67C300.718 109.927 305.96 88.8867 296.216 72.6765C286.472 56.4663 265.432 51.2243 249.222 60.9682C233.012 70.7121 227.77 91.752 237.514 107.962C247.258 124.172 268.297 129.414 284.508 119.67Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.631 111.105C299.106 99.6291 299.106 81.0238 287.631 69.5484C276.156 58.0729 257.55 58.0729 246.075 69.5483C234.599 81.0238 234.599 99.6291 246.075 111.105C257.55 122.58 276.156 122.58 287.631 111.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.844 108.318C294.78 98.3814 294.78 82.2714 284.844 72.3351C274.907 62.3988 258.797 62.3988 248.861 72.3351C238.925 82.2714 238.925 98.3814 248.861 108.318C258.797 118.254 274.907 118.254 284.844 108.318Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.152 105.625C290.601 97.1758 290.601 83.4771 282.152 75.028C273.703 66.5789 260.004 66.5789 251.555 75.028C243.106 83.4771 243.106 97.1758 251.555 105.625C260.004 114.074 273.703 114.074 282.152 105.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.856 107.738C276.472 107.738 284.267 99.9429 284.267 90.3267C284.267 80.7105 276.472 72.915 266.856 72.915C257.239 72.915 249.444 80.7105 249.444 90.3267C249.444 99.9429 257.239 107.738 266.856 107.738Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.366 99.8413C281.621 94.5864 281.621 86.0664 276.366 80.8115C271.111 75.5565 262.591 75.5565 257.336 80.8115C252.081 86.0664 252.081 94.5864 257.336 99.8413C262.591 105.096 271.111 105.096 276.366 99.8413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.519 96.9932C277.201 93.3112 277.201 87.3416 273.519 83.6597C269.838 79.9778 263.868 79.9778 260.186 83.6597C256.504 87.3416 256.504 93.3112 260.186 96.9931C263.868 100.675 269.838 100.675 273.519 96.9932Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.027 90.3258C272.027 93.1821 269.711 95.4979 266.855 95.4979C263.998 95.4979 261.683 93.1821 261.683 90.3258C261.683 87.4696 263.998 85.1538 266.855 85.1538C269.711 85.1538 272.027 87.4696 272.027 90.3258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M301.1 90.3268C301.1 83.1685 298.9 76.5258 295.145 71.03L238.164 109.013C244.276 118.378 254.839 124.571 266.855 124.571C285.768 124.571 301.1 109.24 301.1 90.3268Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.826 87.9188H309.692L313.159 85.1007C313.641 84.7082 313.925 84.1314 313.958 83.4763C313.995 82.7773 313.733 82.0773 313.259 81.6046C312.371 80.7156 310.982 80.6783 309.953 81.5139L302.072 87.9197H267.426C266.074 87.9197 265.056 88.9549 265.056 90.3291C265.056 91.7014 266.075 92.7365 267.426 92.7365H302.086L309.955 99.1319C310.451 99.5349 311.03 99.7344 311.595 99.7344C312.205 99.7344 312.8 99.5024 313.259 99.0421C313.733 98.5684 313.996 97.8685 313.959 97.1685C313.926 96.5134 313.641 95.9366 313.16 95.546L309.704 92.7365H317.826C319.178 92.7365 320.197 91.7014 320.197 90.3281C320.198 88.9539 319.178 87.9188 317.826 87.9188Z",
    fill: "#004275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.507 86.2559H189.873V99.2671H194.507V86.2559Z",
    fill: "#EFD6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.027 79.606H198.393V99.2675H203.027V79.606Z",
    fill: "#EFD6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.642 91.2488H206.914V99.2675H211.642V91.2488Z",
    fill: "#EFD6A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2677_3332",
    x: 0,
    y: 0,
    width: 433,
    height: 378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2677_3332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2677_3332",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataQuality);
export default __webpack_public_path__ + "static/media/Data-Quality.22d7720059f864d1455e03880cfef25a.svg";
export { ForwardRef as ReactComponent };